import React from 'react';
import FormItemContainer from './FormItemContainer';
import FormItemUtil from '../utils/FormItemUtil';


class FormItemTableCell extends FormItemContainer
{
	constructor(props)
	{
		super(props);
        this.state.borderLeft = this.props.borderLeft;this.state.borderRight = this.props.borderRight;
        this.state.borderTop = this.props.borderTop;this.state.borderBottom = this.props.borderBottom;
        this.state.colspan = this.props.colspan;
        this.state.rowspan = this.props.rowspan;
        this.state.horizontalAlignment = this.props.horizontalAlignment;
    }
    
	render()
	{
        let parent = this.props.xml;
        let children = parent.FormItem;
        let that = this;
        var _style = Object.assign({},this.props.customStyle);
        let list = children.map(function(item){
			return FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup);
           });
        _style.borderLeft=this.state.borderLeft;_style.borderRight = this.state.borderRight;
        _style.borderTop = this.state.borderTop;_style.borderBottom = this.state.borderBottom;
        return (<td style={_style} rowSpan={this.state.rowspan} colSpan={this.state.colspan}>
                    <div style={{display:'flex',height:'100%',justifyContent:'center',alignItems:this.state.horizontalAlignment}}>
                        {list}
                    </div>
                </td>);

	}
};

FormItemTableCell.defaultProps = {
};

export default FormItemTableCell;


// WEBPACK FOOTER //
// ./src/formItem/FormItemTableCell.js